"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NVOXpressTransitariosLda = void 0;
exports.NVOXpressTransitariosLda = {
    id: 'nvoxpressTransitariosLda',
    companyName: 'NVOXpress Transitarios Lda',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'nvoxpressTransitariosLda',
    },
    isInternal: false,
    isActive: true,
    countries: ['PT'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTlZPWHByZXNzVHJhbnNpdGFyaW9zTGRhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL05WT1hwcmVzc1RyYW5zaXRhcmlvc0xkYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHdCQUF3QixHQUFVO0lBQzNDLEVBQUUsRUFBRSwwQkFBMEI7SUFDOUIsV0FBVyxFQUFFLDRCQUE0QjtJQUN6QyxjQUFjLEVBQUUsQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDO0lBQzlCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSwwQkFBMEI7S0FDcEM7SUFDRCxVQUFVLEVBQUUsS0FBSztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=